<template>
    <div class="goods-info-content">
        <div class="add-goods">
            <el-button class="add-goods-btn" @click="addGoods">添加新商品</el-button>
        </div>
        <el-table :data="goodsList" class="customTable" style="width: 100%; flex: 1; margin-top: 20px" height="1%">
            <el-table-column label="商品信息" width="450px">
                <template slot-scope="scope">
                    <div class="goods-info">
                        <img :src="scope.row.goods_images" alt="">
                        <span class="goods-name" :title="scope.row.goods_title">{{scope.row.goods_title}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="search_num" label="搜索人数" align="center"></el-table-column>
            <el-table-column prop="click_rate" label="点击率" align="center"></el-table-column>
            <el-table-column prop="conversion_rate" label="转化率" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="220px">
                <template slot-scope="scope">
                    <el-link type="primary" :underline="false" class="a-link" @click="optimizeTitle(scope.row)">优化标题</el-link>
                    <el-link type="success" :underline="false" class="a-link" @click="editGoods(scope.row.id)">编辑</el-link>
                    <el-link type="danger" :underline="false" class="a-link" @click="delGoods(scope.row.id)">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="优化标题" :visible.sync="optimizeTitleDialog" width="500px" @close="handleCloseOptimizeTitleDialog" custom-class="green-dialog add-task-dialog">
            <div class="upload-file-content">
                <el-form :model="optimizeTitleForm" ref="addTaskForm" label-width="66px" class="demo-ruleForm">
                    <el-form-item label="优化标题" prop="target">
                        <el-input v-model="optimizeTitleForm.title" maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer" style="text-align: center;margin-bottom: 20px;">
		        <el-button @click="handleCloseOptimizeTitleDialog">取 消</el-button>
		        <el-button type="primary" @click="saveOptimizeTitle">确 定</el-button>
		    </span>
        </el-dialog>
    </div>
</template>

<script>
    import { stuOpStuOpGoodsList, stuOpStuOptimizeTitle, stuOpStuOpGoodsDel } from '@/utils/apis.js'
    export default {
        name: "GoodsText",
        data() {
            return {
                //商品列表
                goodsList: [],
                //分页
                hotGoodsPages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0,
                },
                //优化标题弹窗
                optimizeTitleDialog: false,
                //优化标题表单
                optimizeTitleForm: {
                    id: '',
                    title: ''
                }
            }
        },
        mounted() {
            this.getGoodsList();
        },
        methods: {
            //获取商品列表
            getGoodsList() {
                let param = {
                    type: '2'
                }
                if (this.$route.query.id) {
                    param.op_id = this.$route.query.id;
                }
                stuOpStuOpGoodsList(param).then((res) => {
                    this.goodsList = res.data;
                }).catch((err) => {
                    console.log(err);
                })
            },
            //添加商品
            addGoods() {
                if (this.$route.query.id) {
                    this.$router.push({
                        path: '/student/trainCenter/goodsInfo/selectClass',
                        query: {
                            id: this.$route.query.id
                        }
                    });
                } else {
                    this.$router.push('/student/examing/goodsInfo/selectClass');
                }

            },
            //优化标题
            optimizeTitle(row) {
                this.optimizeTitleDialog = true;
                this.optimizeTitleForm.id = row.id;
                this.optimizeTitleForm.title = row.goods_title;
            },
            //关闭优化标题弹窗
            handleCloseOptimizeTitleDialog() {
                this.optimizeTitleDialog = false;
            },
            //保存优化标题
            saveOptimizeTitle() {
                this.optimizeTitleDialog = false;
                if (this.optimizeTitleForm.title) {
                    let param = {
                        id: this.optimizeTitleForm.id,
                        name: this.optimizeTitleForm.title
                    }
                    if (this.$route.query.id) {
                        param.op_id = this.$route.query.id;
                    }
                    stuOpStuOptimizeTitle(param).then((res) => {
                        this.$message.success(res.msg);
                        this.getGoodsList();
                    }).catch((err) => {
                        console.log(err);
                    })
                } else {
                    this.$message.warning('请填写标题！');
                }
            },
            //编辑商品
            editGoods(id) {
                if (this.$route.query.id) {
                    this.$router.push({
                        path: '/student/trainCenter/goodsInfo/selectClass',
                        query: {
                            id: this.$route.query.id,
                            g_id: id
                        }
                    })
                } else {
                    this.$router.push({
                        path: '/student/examing/goodsInfo/selectClass',
                        query: {
                            id: this.$route.query.id,
                            g_id: id
                        }
                    })
                }

            },
            //删除
            delGoods(id) {
                this.$confirm(`是否删除该商品，删除将无法恢复`, '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    customClass: 'green-message-box',
                    type: 'warning'
                }).then(() => {
                    let param = {
                        id: id
                    }
                    stuOpStuOpGoodsDel(param).then((res) => {
                        this.$message.success(res.msg);
                        this.getGoodsList();
                    }).catch((err) => {
                        console.log(err);
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .goods-info-content {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 0 20px;
        .add-goods {
            margin-top: 20px;
            .add-goods-btn {
                border: 1px solid #2DC079;
                color: #2DC079;
            }
        }
        .customTable {
            .goods-info {
                display: flex;
                align-items: center;
                img {
                    width: 80px;
                    height: 80px;
                    margin-right: 10px;
                }
                .goods-name {
                    flex: 1;
                    width: 1%;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    font-size: 16px;
                }
            }
            .a-link {
                font-size: 16px;
            }
            ::v-deep {
                .el-table__empty-block {
                    background-image: url("../../../../assets/images/student/goods-null-data.png");
                    background-repeat: no-repeat;
                    background-position: center;
                    .el-table__empty-text {
                        margin-top: 150px;
                    }
                }
            }
        }
    }
    .add-task-dialog {
        .demo-ruleForm {
            .el-form-item {
                display: flex;
                align-items: center;
                ::v-deep .el-form-item__label {
                    margin-bottom: 0;
                }
                ::v-deep .el-form-item__content {
                    width: 1%;
                    flex: 1;
                    margin-left: 10px !important;
                    .el-input-number {
                        width: 100%;
                    }
                    .el-input-number.is-without-controls .el-input__inner {
                        text-align: left;
                    }
                }
            }
        }
        .dialog-footer {
            text-align: center;
        }
    }
</style>